// src/components/PrivacyDisclaimer.jsx
import React from "react";

export default function PrivacyDisclaimer() {
  return (
    <section
      className="mt-4 text-gray-300 space-y-6 leading-relaxed text-sm px-4"
      aria-labelledby="privacy-main-heading"
    >
      {/* Privacy & Data Use */}
      <h2
        id="privacy-main-heading"
        className="text-lg font-bold text-green-400"
      >
        Privacy &amp; Data Use
      </h2>

      <p>
        PAT is an invitation-only analytical environment. Access is controlled
        through authenticated sign-in and additional backend authorisation
        controls.
      </p>

      <p>
        User inputs are processed for analytical purposes within the platform.
        Limited technical logging or service telemetry may be used to support
        reliability, security, debugging, and platform improvement.
      </p>

      <p>
        Users should avoid entering unnecessary sensitive personal, clinical,
        legal, or confidential information unless its inclusion is essential to
        the analytical task and appropriate to the context of use.
      </p>

      {/* Cognitive & Wellbeing Context */}
      <h3 className="text-lg font-bold text-yellow-400">
        Cognitive Scope &amp; Wellbeing
      </h3>

      <p className="text-yellow-300">
        PAT is a probabilistic reasoning system that supports authorised causal
        analysis. It supports analytical clarity, epistemic accountability, and
        structured evaluation of uncertainty and causal-form assumptions across
        domains.
      </p>

      <p className="text-yellow-300">
        While PAT can be used to examine questions related to health, ethics, or
        wellbeing, it does not function as a diagnostic, therapeutic, or
        clinical decision system. Interpretive responsibility remains external
        to the system.
      </p>

      <p className="text-yellow-300 italic">
        Users engaging with personally distressing or high-stakes topics are
        encouraged to seek appropriate professional or community support where
        relevant.
      </p>

      <p className="text-yellow-300 italic">
        In Australia, immediate mental health support is available via:
        <br />
        Lifeline:{" "}
        <a href="tel:131114" className="underline">
          13 11 14
        </a>{" "}
        | Beyond Blue:{" "}
        <a href="tel:1300224636" className="underline">
          1300 22 4636
        </a>
      </p>

      {/* Epistemic Responsibility */}
      <h3 className="text-lg font-bold text-cyan-400">
        Epistemic Responsibility
      </h3>

      <p>
        PAT produces structured analyses, probabilistic and structural
        assessments, and explicit representations of uncertainty. These outputs
        are designed to inform reasoning, not to substitute for judgment,
        expertise, or ethical deliberation.
      </p>

      <p>
        Conclusions, interpretations, and actions derived from PAT outputs
        remain the responsibility of the user. This separation is intentional
        and reflects PAT’s commitment to epistemic humility, transparency, and
        accountable reasoning.
      </p>
    </section>
  );
}
